import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import DataManagement from "../../components/table/DataManagement.jsx";
import { Link, useNavigate } from "react-router-dom";

import { useComprobantes } from "../../hooks_cache/useComprobantes.js";
import { toast } from "react-toastify";
import api from "../../config/axiosConfig.js";
import StatusBadge from "../../components/StatusBadge";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

import useModalProgreso from "../../components/hooks/useModalProgreso.js";

const numeroControlColumn = {
  accessorKey: "codigoGeneracion",
  id: "codigoGeneracion",
  header: "Codigo de generacion",
  cell: ({ row }) => {
    const { id, codigoGeneracion } = row.original;
    return (
      <Link to={`/venta/comprobante/${id}`} className="fw-bold text-nowrap">
        {codigoGeneracion}
      </Link>
    );
  },
};

const columns = [
  numeroControlColumn,
  { accessorKey: "Tercero.nombre", header: "Nombre / Razon social" },
  { accessorKey: "fecEmi", header: "Fecha de emision" },
  { accessorKey: "TipoDTE.descripcion", header: "Tipo de DTE" },
  {
    accessorKey: "totalPagar",
    header: "Importe",
    cell: ({ getValue }) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(getValue()),
  },
  {
    accessorKey: "pendiente",
    header: "Pendiente",
    cell: ({ getValue }) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(getValue()),
  },
  {
    accessorKey: "estado",
    header: "Estado",
    cell: ({ getValue }) => <StatusBadge estado={getValue()} size="" />,
  },
];

function ComprasTable() {
  const { empresaSeleccionada } = useSelector((state) => state.auth);

  const { start, stop } = useModalProgreso({
    modalTitle: "Cargando comprobantes...",
    socketEvents: {
      progress: "dte_email:progreso",
      error: "dte_email:error",
      success: "dte_email:success",
    },
    wide: true,
    showLogs: true,
  });

  const navigate = useNavigate();
  const { data, refetch, isLoading, isFetching } = useComprobantes();

  useEffect(() => {
    if (isFetching) {
      Swal.fire({
        title: "Cargando comprobantes de proveedores...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
    return () => {
      Swal.close();
    };
  }, [isFetching]);

  const comprobantes = isLoading ? [] : data?.filter((c) => c.naturaleza === "compra");

  const [comprobantesSeleccionados, setComprobantesSeleccionados] = useState([]);
  const [rowSelection, setRowSelection] = useState({});

  const handleRowSelectionChange = (newSelection) => {
    setRowSelection(newSelection);

    const idsSeleccionados = Object.keys(newSelection).map(Number);
    const seleccionados = comprobantes.filter((c) => idsSeleccionados.includes(c.id));

    setComprobantesSeleccionados(seleccionados);
  };

  const handleAplicarAbono = () => {
    if (comprobantesSeleccionados.length === 0) {
      toast.warning("Debe seleccionar al menos un comprobante.");
      return;
    }
  };

  const handleBorrarComprobantes = () => {
    if (comprobantesSeleccionados.length === 0) {
      toast.warning("Debe seleccionar al menos un comprobante.");
      return;
    }

    console.log(comprobantesSeleccionados);
  };

  const cargarComprobantes = async () => {
    const empresa = empresaSeleccionada;
    const payload = {
      month: "07",
      year: "2025",
      id_empresa: empresa.id,
    };

    try {
      start();
      const response = await api.post(`dte/proveedores`, payload);
      if (response.status === 200) {
        toast.success("Comprobantes cargados correctamente.");
      }
    } catch (error) {
      console.error("Error al cargar comprobantes:", error);
      toast.error("Error al cargar comprobantes.");
    } finally {
      // stop();
    }
  };

  return (
    <DataManagement
      columns={columns}
      data={comprobantes}
      title="Comprobantes de Proveedores"
      onRowSelectionChange={handleRowSelectionChange}
      actions={[
        <button onClick={handleAplicarAbono} className="btn btn-green btn-sm d-flex me-2 pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:dollar-bold-duotone" />
          Aplicar abono
        </button>,
        <button onClick={handleBorrarComprobantes} className="btn btn-red btn-sm d-flex me-2 pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:dollar-bold-duotone" />
          Borrar comprobantes
        </button>,

        <button onClick={cargarComprobantes} className="btn btn-orange btn-sm d-flex me-2 pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:refresh-bold-duotone" />
          Extraer DTE's del correo
        </button>,
        <button onClick={refetch} className="btn btn-theme btn-sm d-flex pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:refresh-bold-duotone" />
          Actualizar tabla
        </button>,
      ]}
    />
  );
}

export default ComprasTable;
